<template>
  <NoticeCard :class="b()">
    <slot name="title">
      <el-row
        type="flex"
        align="middle"
      >
        <slot name="icon">
          <ImageOrIcon
            v-if="icon"
            :src="icon"
            :size="iconSize"
            :symbol="symbolIcon"
          />
        </slot>
        <slot name="title-text">
          <div :class="[b('title'), 'zk-t-body', 'text-ellipsis']">
            {{ title }}
          </div>
        </slot>
      </el-row>
    </slot>
    <slot name="content" />
    <slot name="footer">
      <el-row
        v-if="$scopedSlots.actions"
        type="flex"
        align="middle"
        justify="end"
        :class="b('actions')"
      >
        <slot name="actions" />
      </el-row>
    </slot>
  </NoticeCard>
</template>

<script>
import NoticeCard from '@/components/notice/NoticeCard';
import theme from '@zk/theme/lib/variables.scss';
export default {
  name: 'CommonNoticeCard',
  components: { NoticeCard },
  bemNS: theme.bemNS,
  inheritAttrs: false,
  props: {
    icon: {
      type: String,
      default: null
    },
    iconSize: {
      type: Number,
      default: 16
    },
    symbolIcon: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss">
@include b(common-notice-card) {
  .zk-image-or-icon {
    margin-right: var(--m-small);
    flex-shrink: 0;
  }
  @include e(title) {
    flex: 1;
  }
  @include e(actions) {
    // margin-top: 15px;
    margin-top: 12px;
    .el-button {
      // color: var(--font-color-1)!important;
      // .zkicon{
      //   color: var(--purpleGray-7)!important;
      // }
      &.el-button--plaintext{
        height: 20px;
      }
      & + .el-button {
        margin-left: 24px;
      }
      &:first-child {
        margin-left: 0;
      }
    }
  }
}
</style>
